// 问题状态颜色
export function statusColor(queStatusId) {
  switch (queStatusId) {
    case "QueStatus001": // 待修改
      return "#eb5757";
    case "QueStatus002": // 已修改
      return "#27ae60";
    case "QueStatus003": // 已复核
      return "#4b6a8f";
    case "QueStatus004": // 已取消
      return "#8b8888";
    default:
      return "";
  }
}
